import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../_defaults";
import { OrderableParameters, PaginationParameters } from "../_types";

/**
 * Converts orderBy array to comma-separated string format for API requests
 */
export function handleOrderableParameters(props: OrderableParameters): Record<string, unknown> {
  const result: Record<string, unknown> = { ...(props || {}) };

  const orderBy = props?.orderBy;
  if (orderBy && Array.isArray(orderBy)) {
    if (orderBy.length > 0) {
      result.orderBy = orderBy.map((order) => `${order.field}:${order.direction}`).join(",");
    } else {
      result.orderBy = orderBy; // Keep empty array as is
    }
  } else if (orderBy === undefined && !props?.orderBy) {
    delete result.orderBy;
  }

  return result;
}

/**
 * Handles pagination and ordering parameters, applying defaults where needed
 */
export function handlePaginatedParameters(props: OrderableParameters & PaginationParameters): Record<string, unknown> {
  const params = handleOrderableParameters(props);

  const result = {
    ...params,
    page: props?.page ?? DEFAULT_PAGE,
    pageSize: props?.pageSize ?? DEFAULT_PAGE_SIZE,
  };

  return result;
}
